var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1583,
    height: 68,
    viewBox: "0 0 1583 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3378_31654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.65 9.28516H726.06C732.7 9.28516 736.27 13.2752 736.27 20.3652C736.27 27.4552 732.71 31.6052 726.18 31.6052H720.65V9.29517V9.28516ZM725.86 29.2652C730.91 29.2652 733.43 25.9952 733.43 20.3552C733.43 14.7152 730.91 11.6052 725.86 11.6052H723.41V29.2652H725.86Z",
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.09 23.355C742.09 17.845 745.58 14.665 749.51 14.665C753.44 14.665 756.93 17.845 756.93 23.355C756.93 28.865 753.44 32.005 749.51 32.005C745.58 32.005 742.09 28.825 742.09 23.355ZM754.13 23.355C754.13 19.565 752.26 16.995 749.51 16.995C746.76 16.995 744.89 19.575 744.89 23.355C744.89 27.135 746.76 29.675 749.51 29.675C752.26 29.675 754.13 27.145 754.13 23.355Z",
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.72 15.0654H764.49L766.87 24.6154C767.22 26.1854 767.51 27.6754 767.82 29.2254H767.95C768.3 27.6754 768.64 26.1654 769.04 24.6154L771.51 15.0654H774.15L776.65 24.6154C777.05 26.1854 777.39 27.6754 777.76 29.2254H777.89C778.24 27.6754 778.54 26.1854 778.88 24.6154L781.21 15.0654H783.79L779.5 31.5954H776.2L773.89 22.7154C773.5 21.1554 773.2 19.6354 772.81 17.9554H772.68C772.33 19.6354 772.01 21.1954 771.58 22.7554L769.34 31.5954H766.17L761.72 15.0654Z",
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.9 15.0653H792.14L792.37 17.4453H792.46C793.99 15.8953 795.63 14.6553 797.83 14.6553C801.2 14.6553 802.72 16.9053 802.72 21.1153V31.5853H800.01V21.4753C800.01 18.3953 799.11 17.0753 796.99 17.0753C795.35 17.0753 794.22 17.9353 792.61 19.6153V31.5853H789.9V15.0553V15.0653Z",
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.54 28.275V7.375H813.25V28.475C813.25 29.325 813.61 29.675 814.01 29.675C814.17 29.675 814.3 29.675 814.6 29.605L814.97 31.745C814.59 31.885 814.12 32.005 813.41 32.005C811.38 32.005 810.54 30.665 810.54 28.275Z",
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.38 23.355C820.38 17.845 823.87 14.665 827.8 14.665C831.73 14.665 835.22 17.845 835.22 23.355C835.22 28.865 831.73 32.005 827.8 32.005C823.87 32.005 820.38 28.825 820.38 23.355ZM832.41 23.355C832.41 19.565 830.54 16.995 827.79 16.995C825.04 16.995 823.17 19.575 823.17 23.355C823.17 27.135 825.04 29.675 827.79 29.675C830.54 29.675 832.41 27.145 832.41 23.355Z",
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.59 27.3053C840.59 23.7053 843.6 21.9053 850.42 21.1353C850.42 19.0053 849.73 16.9653 847.12 16.9653C845.27 16.9653 843.6 17.8753 842.35 18.7353L841.29 16.8153C842.76 15.8153 845.01 14.6553 847.58 14.6553C851.49 14.6553 853.14 17.3353 853.14 21.4453V31.5853H850.9L850.67 29.6053H850.58C849.05 30.9153 847.27 31.9853 845.29 31.9853C842.61 31.9853 840.6 30.2653 840.6 27.2853L840.59 27.3053ZM850.42 27.5653V22.9753C845.06 23.6453 843.24 24.9953 843.24 27.1053C843.24 28.9853 844.47 29.7453 846.05 29.7453C847.63 29.7453 848.87 28.9653 850.42 27.5553V27.5653Z",
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.67 23.355C859.67 17.995 862.95 14.665 866.6 14.665C868.46 14.665 869.68 15.385 871.09 16.575L870.98 13.745V7.375H873.69V31.595H871.45L871.22 29.645H871.13C869.89 30.925 868.18 32.005 866.27 32.005C862.27 32.005 859.68 28.865 859.68 23.355H859.67ZM870.97 27.395V18.735C869.6 17.475 868.37 17.015 867.07 17.015C864.51 17.015 862.48 19.565 862.48 23.325C862.48 27.285 864.07 29.645 866.87 29.645C868.35 29.645 869.63 28.905 870.98 27.395H870.97Z",
    fill: "currentColor",
    stroke: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3378_31654",
    x: 713.275,
    y: 0,
    width: 173.79,
    height: 45.3799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3378_31654"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3378_31654",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadText);
export default __webpack_public_path__ + "static/media/download-text.e5e11f41cd54b47b3bd6889e92b54289.svg";
export { ForwardRef as ReactComponent };